import React from 'react';
import './Products.css';

function Products() {
  return (
    <main className="products-page">
      <section className="page-header">
        <div className="page-header-inner">
          <span className="section-label">Our Offerings</span>
          <h1>Products</h1>
          <p>Precision silicon wafers for every stage of semiconductor development.</p>
        </div>
      </section>

      <section className="coming-soon-section">
        <div className="coming-soon-inner">
          <div className="coming-soon-icon">⚙️</div>
          <h2>Coming Soon</h2>
          <p>
            We are currently finalizing our product catalog. Our range of precision silicon wafers —
            spanning standard, epitaxial, SOI, and specialty grades — will be listed here shortly.
          </p>
          <p>
            In the meantime, reach out directly to discuss your specific wafer requirements.
          </p>
          <a href="/contact" className="btn-primary">Contact Us</a>
        </div>
      </section>

      {/* Preview Cards */}
      <section className="product-preview">
        <div className="product-preview-inner">
          <h2>What to Expect</h2>
          <div className="preview-grid">
            {[
              { icon: '🔵', title: 'Standard Silicon Wafers', desc: 'P-type and N-type wafers in various diameters from 2" to 12" for general semiconductor applications.' },
              { icon: '🟣', title: 'Epitaxial Wafers', desc: 'High-purity epitaxial layers grown on silicon substrates for advanced device fabrication.' },
              { icon: '🟢', title: 'SOI Wafers', desc: 'Silicon-on-Insulator wafers for low-power, high-performance CMOS and RF applications.' },
              { icon: '🟡', title: 'Specialty Wafers', desc: 'Custom specifications for research, MEMS, photonics, and emerging technology applications.' },
            ].map((p) => (
              <div className="preview-card" key={p.title}>
                <span className="preview-icon">{p.icon}</span>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
                <span className="coming-soon-tag">Coming Soon</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Products;
